

/*
 * @author: xd
 * @Date: 2021-12-16 21:24:52
 * @LastEditors: xd
 * @LastEditTime: 2022-06-25 14:26:45
 * @Description: 功能
 */
import { system } from './system';
import { BaseClass } from "../base/DreamScape";
import { Login } from "../modules/user/login";
import { UserInfo } from "../modules/user/UserInfo";
import { Secret } from "../modules/Secret/secret";
import { DataClass } from "./DataClass";
import { ToolBox } from "./toolBox";
import { Cache } from "./cache";
/**
 * @description: 主入口类
 * @param {string} pid 初始化项目的编号
 */
export class Project extends BaseClass {
  User: Login;
  Data: DataClass;
  toolbox: typeof ToolBox;
  UserInfo: UserInfo;
  cache: Cache;
  system: system;

  /**
   * @description: 初始化
   * @param {string} url 网络服务地址
   * @param {string} pid 项目id
   */
  constructor(url: string, pid: string) {
    super();

    let appItem = this.scanAppid(url, pid);
    this.User = new Login(appItem);

    this.UserInfo = new UserInfo();
    this.Data = new DataClass(appItem);
    this.cache = new Cache;
    this.system = new system(url);
    this.toolbox = ToolBox;
  }
  /**
   * @description: 设置默认属性
   * @param {string} mPid
   * @return {*}
   */
  private scanAppid(urlpath: string, mPid: string): any {
    let ss = new Secret();
    let applist = [
      {url: urlpath,pid: "SYPANO", appid: "27208914" },
      {url: urlpath, pid: "tykg", appid: "16884957" },
      {url: urlpath, pid: "SYKFGL", appid: "92837277" },
      {url: urlpath, pid: "SYWWBH", appid: "92837277" },
      {url: urlpath, pid: "SYBGGL", appid: "92837277" },
      {url: urlpath, pid: "SYCWGL", appid: "92837277" },
      {url: urlpath, pid: "SYDAGL", appid: "92837277" },
      {url: urlpath, pid: "SYKYGL", appid: "92837277" },
      {url: urlpath,pid: "SYKFGL", appid: "92837277" },
      {url: urlpath, pid: "SYRSGL", appid: "92837277" },
      {url: urlpath, pid: "SYXMGL", appid: "92837277" },
      {url: urlpath, pid: "SYYHGL", appid: "92837277" },
      {url: urlpath, pid: "SYZCGL", appid: "92837277" },
      {url: urlpath, pid: "SYTSGL", appid: "92837277" },
      {url: urlpath, pid: "SYKTXM", appid: "92837277" },
      {url: urlpath, pid: "SYXBDXZHUZ", appid: "92837277" },
    ];
    let app;
   // localStorage.setItem("url", ss.Encrypt1(urlpath));
    applist.forEach((item) => {
      if (item.pid == mPid) {
        localStorage.setItem("pid", ss.Encrypt1(item.pid));
        localStorage.setItem("aid", ss.Encrypt1(item.appid));
        app=item;
      }
    });
    return app;
  }
}
